export default "<input type=\"password\" [attr.class]=\"defaultCss\" [(ngModel)]=\"value\" (ngModelChange)=\"inputChanged($event)\"  />"